module.exports = __webpack_public_path__ + "img/Artha Prima Finance.2c37a56c.png";